//dependencias
import React, { Component } from 'react';

//componentes
import DosificacionDEPN from './dosificacionDEPN'

class Index extends Component {

    render(){
        return(
            <div>
                <DosificacionDEPN />
            </div>
        );
    }

}
export default Index;